import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function SiteLockGuard({ children }) {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const unlocked = localStorage.getItem("site_unlocked") === "true";

        // ⏳ եթե ուզում ես ժամկետով լինի՝ օրինակ 12 ժամ
        const time = Number(localStorage.getItem("site_unlocked_time") || 0);
        const maxAge = 1000 * 60 * 60 * 12; // 12 ժամ
        const expired = !time || Date.now() - time > maxAge;

        if (!unlocked || expired) {
            localStorage.removeItem("site_unlocked");
            localStorage.removeItem("site_unlocked_time");

            if (location.pathname !== "/unlock") {
                navigate("/unlock", {
                    replace: true,
                    state: { from: location.pathname },
                });
            }
        }
    }, [location.pathname, navigate]);

    return children;
}
